import React, {useCallback, useMemo, useState} from 'react';

export const usePagination = () => {
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [take, setTake] = useState(10);
    const pages = useMemo(() => {
        const amount = Math.ceil(totalCount / take);

        return new Array(amount > 0 ? amount : 1).fill(null);
    }, [totalCount, take]);

    const next = useCallback( () => {
        setPage(prev => prev + 1);
    }, []);

    const prev = useCallback( () => {
        setPage(prev => prev - 1);
    }, []);

    return {
        setTotalCount,
        totalCount,
        page,
        pages,
        take,
        next,
        prev,
        setPage,
        setTake,
    };
};